<template>
      <a-col>
          <div class="calendar_container">
              <img src="../../assets/icons/calendar.svg" alt="">
              <a-date-picker 
                size="large" 
                :locale="locale" 
                :default-value="moment()"
                format="YYYY-MM-DD"
                suffix-icon=" " />
          </div>
          <div>
            <p class="list_result_num">共 {{testData.length}} 筆資料</p>
            <a-list item-layout="horizontal" :split="true" :data-source="testData" class="schedule_list_container">
                <a-list-item slot="renderItem" slot-scope="item,index" :id="item.id" @click="turnToDetailData(item.id)">
                    <div class="list_serial_num">
                        <span>{{index+1}}</span>
                    </div>
                    <div class="list_content">
                        <div class="period_container">
                            {{item.startTime}}
                            <img src="../../assets/icons/schedule_time_arrow.svg" alt="" class="time_arrow">
                            {{item.endTime}}
                        </div>
                        <div class="position_container">
                            <img src="../../assets/icons/start_position_icon.svg" alt="">
                            <div>
                                {{item.startPoint}}
                            </div>
                        </div>
                        <div class="between_line_container">
                            <img src="../../assets/icons/position_between_line.svg" alt="" class="between_line">
                        </div>
                        <div class="position_container">
                            <img src="../../assets/icons/end_position_icon.svg" alt="">
                            {{item.endPoint}}
                        </div>
                        <div class="total_text_container">
                            <div>
                                <span>累計里程</span> {{item.mileage}} km
                            </div>
                            <div>
                                <span>總計</span> {{item.totalTime}}
                            </div>
                        </div>
                    </div>

                </a-list-item>
            </a-list>
          </div>
      </a-col>
</template>

<script>
    import locale from 'ant-design-vue/es/date-picker/locale/zh_TW';

    export default {
        data() {
            return {
                locale,
                // 測試假資料
                testData: [
                    {   
                        id: 'schedule1',
                        startTime: '09:00',
                        endTime: '12:31',
                        startPoint: '新北市新莊區新北大道三段X號',
                        endPoint: '台中市西屯區XX路93巷8弄9號',
                        mileage: 5000,
                        totalTime: '02時31分',
                    },
                    {   
                        id: 'schedule2',
                        startTime: '12:31',
                        endTime: '14:00',
                        startPoint: '台中市西屯區XX路93巷8弄9號',
                        endPoint: '中都PDS',
                        mileage: 1600,
                        totalTime: '01時29分',
                    },
                    {   
                        id: 'schedule3',
                        startTime: '14:00',
                        endTime: '17:00',
                        startPoint: '中都PDS',
                        endPoint: '彰化縣溪湖鎮XX路6號',
                        mileage: 4000,
                        totalTime: '03時',
                    },        
                ],
            }
        },
        methods: {
            turnToDetailData(param) {
                this.$router.push(`schedule/detail/${param}`);
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/global.scss";

    .calendar_container {
        position: relative;
        padding: 0 12px;
        img {
            position: absolute;
            left: 25px;
            top: 50%;
            transform: translateY(-50%);
            z-index: 1;
        }
    }

    .list_result_num {
        padding: 8px 12px;
        text-align: right;
        line-height: 24px;
        color: rgba(52, 55, 65, 0.6);
        margin: 0;
    }

    .schedule_list_container {
        padding: 0 12px;
        .ant-list-item {
            justify-content: flex-start;
            padding: 14px 0;
            align-items: stretch;
            &:first-child {
                padding-top: 0;
            }
            .list_serial_num {
                flex-basis: 12%;
                span {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: rgba(52, 55, 65, 0.6);
                    border-radius: 50%;
                    color: #FFFF;
                    width: 1.5rem;
                    height: 1.5rem;
                    font-weight: 900;
                    margin-left: 2px;
                }
            }
            .list_content {
                flex-basis: 88%;
                >div {
                    margin-bottom: 3px;
                    line-height: 24px;
                    color: #343741;
                    &:nth-child(2) {
                        margin-bottom: 4px;
                    }
                    span {
                        color: rgba(52, 55, 65, 0.6);
                        font-size: 12px;
                    }
                    .time_arrow {
                        margin: 0 8px 3px 8px;
                    }                
                    img {
                        margin: 0 5px 3px 0;
                    }
                }
                .total_text_container {
                    display: flex;
                    div {
                        &:first-child {
                            flex-basis: 50%;
                        }
                        &:last-child {
                            flex-basis: 50%;
                        }
                    }
                }
                .period_container {
                    margin-left: 2px;
                }

                .between_line_container {
                    padding: 0;
                    position: relative;
                    height: 2px;
                    img {
                        position: absolute;
                        top: -10px;
                        left: 2px;
                    }
                }
                .position_container {
                    display: flex;
                }
            }
        }
    }
</style>